var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTicketStateRegisteredIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon ticket-state-registered-icon",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 13,
    fill: "#ff8000",
    className: "fill-circle",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    className: "fill-symbol",
    transform: "translate(9.765 6.588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.941 9.882a.706.706 0 11-1.412 0V8.455c.016-.686.484-1.154 1.205-1.365 1.389-.427 2.325-1.427 2.325-2.855 0-1.562-1.317-2.823-2.824-2.823-1.562 0-2.823 1.176-2.823 2.823a.706.706 0 01-1.412 0C0 1.785 1.915 0 4.235 0 6.51 0 8.471 1.88 8.471 4.235c0 2.124-1.392 3.61-3.332 4.207-.182.054-.197.06-.198.035v1.405z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.235,
    cy: 13.059,
    r: 1.059
  })))));
}

export default SvgTicketStateRegisteredIconSv;